module.exports = __webpack_public_path__ + "img/shubham.71b4626e.jpg";